export const taskPriorityOptions = [
    { value: 'urgent', label: 'Urgent' },
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' }
];

export const todayLeaveOptions = [
    { label: "Sick Leave", value: "SL" },
    { label: "Outdoor Duty", value: "OD" },
    { label: "Half Day First Half", value: "HDFH" },
    { label: "Half Day Second Half", value: "HDSH" },


];

export const leaveOptions = [
    { label: "Sick Leave", value: "SL" },
    { label: "Earned Leave", value: "EL" },
    { label: "Casual Leave", value: "CL" },
    { label: "Half Day First Half", value: "HDFH" },
    { label: "Half Day Second Half", value: "HDSH" },


];

export const ResourceTypeOptions = [
    { value: 'superAdmin', label: 'Super Admin' },
    { value: 'admin', label: 'Admin' },
    { value: 'humanResource', label: 'HR' },
    { value: 'manager', label: 'Manager' },
    { value: 'teamlead', label: 'TeamLead' },
    { value: 'employee', label: 'Employee' },
    { value: 'intern', label: 'Intern' },
    { value: 'contractual', label: 'Contractual' }
]